<template>
  <div class="page">
    <report-cover image="cover-sustain.jpg" headline="Nachhaltigkeit<br> bei enercity" @cover-change="coverChange"/>
    <div class="container">
      <h5>Eine lebenswerte Zukunft für die nachfolgenden Generationen zu sichern ist die größte gesellschaftliche Herausforderung unserer Zeit. Als Energiedienstleister hat enercity nicht nur eine besondere Verantwortung, sondern auch eine große Chance, den hierzu notwendigen Umbau des Energiesystems voranzutreiben.</h5>
      <div class="row">
        <div class="col">
          <div class="image-box">
            <img src="../assets/images/report/solar.jpg" alt="">
          </div>
        </div>
        <div class="col">
          <p>Nachhaltigkeit ist ein Kernaspekt unserer Unternehmensphilosophie und einer unserer vier zentralen Unternehmenswerte. Gemeinsam mit und für unsere Kundinnen und Kunden setzen wir konsequent auf den Ausbau erneuerbarer Energien – wir treiben die Energiewende im Bereich der Wind- und Solarenergie sowie der Wärmeversorgung aktiv voran. Ökostrom, klimafreundliche Wärme, Energieeffizienz, E-Mobilität und mehr: Mit unseren Produkten und Dienstleistungen machen wir Kundinnen und Kunden sowie Partnerinnen und Partner zum Teil der Energiewende.</p>
          <p>In den vergangenen Jahren haben wir viel erreicht. Und doch wissen wir, dass es immer noch besser geht. Daher haben wir uns zum Ziel gesetzt, alle unsere nicht finanziellen Aktivitäten systematisch zu erfassen, auszuwerten und auf dieser Basis kontinuierlich zu optimieren. Im Jahr 2020 hat enercity mit der Implementierung eines an den Richtlinien der Global Reporting Initiative (GRI) sowie des Deutschen Nachhaltigkeitskodex (DNK) orientierten Nachhaltigkeitsmanagements begonnen.</p>
          <p>Die folgende nicht finanzielle Erklärung ist in Anlehnung an die Vorgaben des 2017 in Kraft getretenen CSR-Richtlinie-Umsetzungsgesetzes (CSR-RL-UG) verfasst, das die Offenlegung der nicht finanziellen Aktivitäten von Unternehmen unter bestimmten Voraussetzungen regelt. enercity ist nicht zur Offenlegung nach dem CSR-RL-UG verpflichtet, sondern gibt diese Erklärung freiwillig ab.</p>
        </div>
      </div>
      <accordion/>
    </div>
    <page-footer @scroll-to-top="toTop"/>
  </div>
</template>

<script>
import ReportCover from "@/elements/ReportCover";
import PageFooter from "@/components/PageFooter";
import Accordion from "@/elements/Accordion";
export default {
  name: "PageSustainability",
  components: {Accordion, PageFooter, ReportCover},
  methods: {
    toTop() {
      this.$emit('scroll-to-top');
    },
    coverChange(data) {
      this.$emit('cover-change', data);
    }
  },
  emits: ['change-content', 'scroll-to-top', 'cover-change'],
  mounted() {
    this.$emit('change-content', {showContent: true, title: 'Nachhaltigkeitsbericht'});
  }
}
</script>

<style scoped>
.page {
  position: relative;
  display: block;
  background-color: #fff;
  min-height: 200vh;
  font-weight: 400;
  color: #111C24;
}
.container {
  position: relative;
  display: block;
  margin: calc(2.5% + 30px) auto;
  padding: 0 40px;
  max-width: 1020px;
}
h5 {
  font-size: 18px;
  font-weight: 700;
}
h2 {
  margin: 1.6em -0.05em 0.6em;
  color: #102D61;
}
.row {
  display: flex;
  margin: 2.5em 0 6em;
}
.col:first-child {
  flex: 1 1 35%;
  max-width: 35%;
}
.col:last-child {
  max-width: 65%;
}
.col > p:first-child {
  margin-top: 0;
}
.col .image-box {
  padding-right: 40px;
  margin-top: 0.4em;
}
img {
  display: block;
  max-width: 100%;
}
@media(max-width: 999px) {
  h5 {
    font-size: 16px;
  }
  .page {
    font-size: 15px;
  }
  .col .image-box {
    padding-right: 30px;
    margin-top: 0.25em;
  }
  .container {
    padding: 34px;
  }
}
@media(max-width: 767px) {
  .container {
    padding: 12px 20px 40px;
    margin-top: 0;
  }
  .row {
    margin-bottom: calc(30px + 5%);
  }
}
@media(max-width: 567px) {
  .row {
    display: block;
  }
  .col:first-child, .col:last-child {
    max-width: 100%;
  }
  .col .image-box {
    padding-right: 0;
    margin-bottom: calc(26px + 3%);
  }
}
</style>